import { getAuth, GoogleAuthProvider, OAuthProvider, signInWithPopup } from "firebase/auth";
import { IonIcon } from "@ionic/react";
import { logoGoogle } from "ionicons/icons";

import LoginButton, { Props as ButtonProps } from "./login-button";

export interface Props extends Omit<ButtonProps, "icon" | "text"> {}
export default function GoogleLoginButton({ onLogin, ...props }: Props) {
    const login = async () => {
        const provider = new GoogleAuthProvider();

        const auth = getAuth();

        try {
            const result = await signInWithPopup(auth, provider);
            const credential = OAuthProvider.credentialFromResult(result);

            if (!credential?.accessToken) {
                throw new Error("NO_TOKEN");
            }

            onLogin?.(null, {
                token: credential.accessToken,
                expiration: Date.now(),
            });
        } catch (err) {
            //-- authentication error, ignore
            console.log(err);
            onLogin?.(err);
        }
    };

    return <LoginButton {...props} onClick={login} text={"Google"} icon={<IonIcon icon={logoGoogle} />} />;
}
